import { defineComponentMetadata } from '@/components/define'
import { CommentAreaV3, CommentItem, CommentReplyItem } from '@/components/utils/comment-apis'
import { matchUrlPattern } from '@/core/utils'
import { feedsUrls } from '@/core/utils/urls'

const entry = async () => {
  const { forEachCommentItem, addMenuItem } = await import('@/components/utils/comment-apis')

  const findParentFeedsUrl = (commentElement: HTMLElement) => {
    if (document.URL.match(/\/\/t\.bilibili\.com\/(\d+)/)) {
      return ''
    }
    if (feedsUrls.every(url => !matchUrlPattern(url))) {
      return ''
    }
    let element: HTMLElement | null = commentElement
    while (element !== null && element !== document.body) {
      if (element.hasAttribute('data-did')) {
        return `https://t.bilibili.com/${element.getAttribute('data-did')}`
      }
      element = element.parentElement
    }
    return ''
  }
  const addCopyLinkButton = (comment: CommentItem) => {
    const processItems = (items: CommentReplyItem[]) => {
      items.forEach(item => {
        if (item.parent instanceof CommentAreaV3) {
          item.parent.getMenuElement(item).then(menu => {
            if (!menu) {
              return
            }
            const originalItem = menu
              .querySelectorAll('li')
              .find(li => li.textContent === '复制评论链接') as HTMLElement | undefined
            if (!originalItem) {
              return
            }
            originalItem.style.display = 'none'
          })
        }
        addMenuItem(item, {
          className: 'copy-link',
          text: '复制链接',
          action: async () => {
            const url = findParentFeedsUrl(item.element) || document.URL.replace(location.hash, '')
            await navigator.clipboard.writeText(`${url}#reply${item.id}`)
          },
        })
      })
    }
    processItems([comment, ...comment.replies])
    comment.addEventListener('repliesUpdate', e => processItems(e.detail))
  }
  forEachCommentItem({
    added: addCopyLinkButton,
  })
}
export const component = defineComponentMetadata({
  name: 'copyCommentsLink',
  displayName: '复制评论链接',
  entry,
  tags: [componentsTags.utils],
})
